import React from "react";
import { Link } from "react-router-dom";
import { Box, AppBar, Toolbar, Button, Typography } from "@mui/material";

import logo from "../assets/Main_Logo_AI_Colored_Padding.png"; // Add your logo path here

function NavBar() {
  return (
    <>
    {/* <AppBar position="static" sx={{backgroundColor: "rgb(0, 171, 85)"}}>
      <Toolbar>
        <Box sx={{ display: "flex", flexGrow: 1, gap: 2 , backgroundColor: "rgb(0, 171, 85)"}}>
          <Button component={Link} to="/" color="inherit">Home</Button>
          <Button component={Link} to="/sslcertcheck" color="inherit">SSL Scan</Button>
          <Button component={Link} to="/dnscheck" color="inherit">DNS Scan</Button>
          <Button component={Link} to="/blacklistcheck" color="inherit">Blacklist Scan</Button>
          <Button component={Link} to="/mailservercheck" color="inherit">Mail Server Scan</Button>
          <Button component={Link} to="/cookiecheck" color="inherit">Cookie Scan</Button>
          <Button component={Link} to="/privacypolicycheck" color="inherit">Privacy Policy Scan</Button>
          <Button component={Link} to="/termsofservicecheck" color="inherit">TOS Scanner</Button>
          <Button component={Link} to="/gdprcheck" color="inherit">GDPR Scanner</Button>
          <Button component={Link} to="/pentest" color="inherit">Pentest</Button>
          <Button component={Link} to="/attacksurface" color="inherit">Attack Surface</Button>
        </Box>
      </Toolbar>
    </AppBar> */}
    <Box
        sx={{
          textAlign: "center",
          px: 3,
          py:2
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "left",
            alignItems: "left",
            mb: 2,
            mt: 2,
          }}
        >
         <a href="https://portend.ai/" target="_blank"><img src={logo} alt="Portend Logo" style={{maxWidth:'200px', marginRight: 10 }} /></a> 
          
        </Box>
        
      </Box>
      </>
    
  );
}

export default NavBar;
